import { type AnalyticsManager } from "services/analytics/analyticsManager";
import { type IdentityQuestionsStore } from "services/questions/au/identityQuestionsStore";
import { type AbnSoleTraderQuestionsStore } from "services/questions/au/soleTrader/abnSoleTraderQuestionsStore";
import { type DirectorSoleTraderQuestionsStore } from "services/questions/au/soleTrader/directorSoleTraderQuestionsStore";
import { type SoleTraderDecisionQuestionsStore } from "services/questions/au/soleTraderDecisionQuestionsStore";
import { RegisterFormStep } from "services/registerForm/registerFormStep";
import { RegisterFormSteps } from "services/registerForm/registerFormSteps";
import { RegisterFormStepsStoreBase } from "services/registerForm/registerFormStepsStoreBase";
import { SoleTraderFormStep } from "./constants";

export class AbnSoleTraderRegisterFormStepsStore extends RegisterFormStepsStoreBase<SoleTraderFormStep> {
  protected readonly _steps: RegisterFormSteps<SoleTraderFormStep> = new RegisterFormSteps<SoleTraderFormStep>([
    new RegisterFormStep(SoleTraderFormStep.FLOW_SELECT, "Select the option"),
    new RegisterFormStep(SoleTraderFormStep.CONSENT, "Before you get started"),
    new RegisterFormStep(
      SoleTraderFormStep.SOLE_TRADER_DECISION,
      "ABN entitlement",
      this._soleTraderDecisionQuestionsStore,
    ),
    new RegisterFormStep(SoleTraderFormStep.DIRECTOR, "Personal Information", this._directorSoleTraderQuestionsStore),
    new RegisterFormStep(SoleTraderFormStep.ABN, "ABN details", this._abnSoleTraderQuestionsStore),
    new RegisterFormStep(SoleTraderFormStep.IDENTITY, "Identity Verification", this._identityQuestionsStore),
    new RegisterFormStep(SoleTraderFormStep.BASKET, "Payment Details"),
    new RegisterFormStep(SoleTraderFormStep.CONFIRM, "Confirm and submit"),
    new RegisterFormStep(SoleTraderFormStep.CHARGE, "Payment"),
    new RegisterFormStep(SoleTraderFormStep.COMPLETE, "Complete"),
  ]);

  readonly confirmStep: SoleTraderFormStep = SoleTraderFormStep.CONFIRM;
  readonly completeStep: SoleTraderFormStep = SoleTraderFormStep.COMPLETE;

  constructor(
    protected readonly _analyticsManager: AnalyticsManager,
    private readonly _soleTraderDecisionQuestionsStore: SoleTraderDecisionQuestionsStore,
    private readonly _directorSoleTraderQuestionsStore: DirectorSoleTraderQuestionsStore,
    private readonly _abnSoleTraderQuestionsStore: AbnSoleTraderQuestionsStore,
    private readonly _identityQuestionsStore: IdentityQuestionsStore,
  ) {
    super(_analyticsManager);
  }
}
